import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Separator } from "@/components/ui/separator";
import { APP_NAME, useTenantDisplayName } from "@/features/branding";

import { getCardV2faqData } from "../helpers/get-faq-data";

export const CardFAQsPage = () => {
  const { t } = useTranslation();
  const clientName = useTenantDisplayName() ?? APP_NAME;
  const datasource = getCardV2faqData({
    cardClient: clientName,
    client: clientName,
  });

  return (
    <ul className="bg-white h-full p-4">
      <li className="text-muted-foreground font-medium text-sm px-3 py-4">
        {t("card_faq_description")}
      </li>
      {datasource.map((item, index) => (
        <React.Fragment key={index}>
          {index !== 0 && (
            <Separator className="my-2" key={`divider-${index}`} />
          )}
          <li className="px-3 py-2" key={`list-item-${index}`}>
            <Link
              className="decoration-none text-primary"
              to={`/card/faq/${index}`}
            >
              {typeof item.question === "string"
                ? t(item.question)
                : t(...item.question)}
            </Link>
          </li>
        </React.Fragment>
      ))}
    </ul>
  );
};
